<template>
  <div class="post-header">
    <post-user-icon :icon="post.author_logo"/>
    <div class="post-preview-header__info">
      <div class="post-header__user-name post-preview-header__user-name">{{ post.author }}</div>
      <span class="post-header-date">
         {{ datePost }}
      </span>
    </div>
    <img class="post-preview-header__icon" v-if="post.network_name === 'vk'" src="../../../../../../assets/images/icon-vk.svg">
    <img class="post-preview-header__icon" v-if="post.network_name === 'fb'" src="../../../../../../assets/images/icon-fb.svg">
    <img class="post-preview-header__icon" v-if="post.network_name === 'tw'" src="../../../../../../assets/images/icon-tw.svg">
    <img class="post-preview-header__icon" v-if="post.network_name === 'gs'" src="../../../../../../assets/images/icon-smi.svg">
  </div>
</template>

<script>
import PostUserIcon from '../../postUserIcon.vue';

export default {
  name: 'postPreviewHeader',
  components: { PostUserIcon },
  props: {
    post: {
      type: Object,
      default() {
        return {};
      },
    },
    datePost: {
      type: String
    }
  },
  methods: {
    sourceIcon(source) {
      if (source === 'vk') return 'icon-vk.svg';
      if (source === 'fb') return 'icon-fb.svg';
      if (source === 'gs') return 'icon-smi.svg';
      if (source === 'tw') return 'icon-tw.svg';
      return 'icon-stab.png';
    },
  }
};
</script>

<style lang="stylus">
.post
  width 100%
  &-header
    &__user-name
      margin 0 1em
      color #000000
    &__counters
      display flex
      align-items center
      margin-left auto
  &-counter
    display flex
    align-items center
    &__icon
      margin-left .8em
      height .8em
      width auto
    &__count
      margin-left .3em
.post-preview-header__user-name
  width 150px;
  margin-bottom .3em
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
.post-header-date
  font-style: normal;
  font-weight: 500;
  font-size: 9px;
  line-height: normal;
  color: #55626F;
  margin-left 1.2em

.post-preview-header__icon
  position absolute
  top 20px
  right 20px
</style>
